export default {
  cattle: [
    { text: 'Bulls', value: 'Bulls' },
    { text: 'Calves', value: 'Calves' },
    { text: 'Cows', value: 'Cows' },
    { text: 'Heifers', value: 'Heifers' },
    { text: 'Steers', value: 'Steers' },
    { text: 'Young Bulls', value: 'Young Bulls' }
  ],
  sheep: [
    { text: 'Ewes', value: 'Ewes' },
    { text: 'Gimmers', value: 'Gimmers' },
    { text: 'Hoggs', value: 'Hoggs' },
    { text: 'Lambs', value: 'Lambs' },
    { text: 'Rams', value: 'Rams' },
    { text: 'Shearlings', value: 'Shearlings' },
    { text: 'Wethers', value: 'Wethers' }
  ],
  pigs: [
    { text: 'Barrows', value: 'Barrows' },
    { text: 'Boars', value: 'Boars' },
    { text: 'Gilts', value: 'Gilts' },
    { text: 'Sows', value: 'Sows' },
    { text: 'Weaners', value: 'Weaners' }
  ],
  goats: [
    { text: 'Bucks', value: 'Bucks' },
    { text: 'Does', value: 'Does' },
    { text: 'Kids', value: 'Kids' },
    { text: 'Wethers', value: 'Wethers' },
    { text: 'Yearlings', value: 'Yearlings' }
  ]
}
